import { getMap } from '../game/model/mapCatalog'
import type { MapDefinition } from '../game/model/types'
import { mapDraftStore } from './draftStore'

/** Builtin maps stay read-only; drafts get a distinct id when needed. */
export function draftIdForSave(map: MapDefinition, sourceLabel: string): string {
  const builtin = getMap(map.id)
  if (builtin || sourceLabel.startsWith('builtin:')) {
    if (map.id.endsWith('-copy')) return map.id
    return `${map.id}-copy`
  }
  return map.id
}

export function saveEditorDraft(map: MapDefinition, sourceLabel: string): {
  map: MapDefinition
  draftId: string
} {
  const id = draftIdForSave(map, sourceLabel)
  const toSave: MapDefinition = {
    ...structuredClone(map),
    id,
    schemaVersion: map.schemaVersion ?? 1
  }
  mapDraftStore.saveDraft(toSave)
  return { map: toSave, draftId: id }
}
